import { WorklistTable } from "./worklistTable";

export const WorklistScreen = ({ facilityNumber, config }) => {
  return <WorklistTable facilityNumber={facilityNumber} {...config} />;
};
